// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

import { IRetryPolicy, RetryContext } from '@microsoft/signalr';

// 0, 2, 10, 30 second delays before reconnect attempts.
const DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [0, 2000, 5000, 10000, 20000, 20000, 20000, 20000, 20000,
   20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000,
    20000, 20000, 20000,  20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000, 20000];

/** @private */
export class DefaultReconnectPolicy implements IRetryPolicy {
  private readonly retryDelays: Array<number | null>;

  constructor(retryDelays?: number[]) {
    this.retryDelays = retryDelays !== undefined ? [...retryDelays, null] : DEFAULT_RETRY_DELAYS_IN_MILLISECONDS;
  }

  public nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
    if (retryContext.previousRetryCount >= this.retryDelays.length){
      return 20000;
    }

    return this.retryDelays[retryContext.previousRetryCount];
  }
}
